import {
  FETCH_MOST_TUTORIALS,
  FETCH_TUTORIAL_LIST,
  FETCH_TUTORIAL_STEPS,
  UPDATE_STEP,
  UPDATE_STEP_NB,
  ANIMATE_STEP,
  ANIMATE_ALL,
  UPDATE_FRAME,
  ANIMATE_ALL_TERM
} from './constants'

export const fetchMostTutorials = {
  request: (currentPhoneId) => ({
    type: FETCH_MOST_TUTORIALS.REQUEST,
    currentPhoneId
  }),
  success: (tutorials, currentPhoneId) => ({
    type: FETCH_MOST_TUTORIALS.SUCCESS,
    tutorials,
    currentPhoneId
  })
}

export const fetchTutorialList = {
  request: (currentPhoneId, presales, subdomain) => ({
    type: FETCH_TUTORIAL_LIST.REQUEST,
    currentPhoneId
  }),
  success: (currentPhoneId, tutorials) => ({
    type: FETCH_TUTORIAL_LIST.SUCCESS,
    currentPhoneId,
    tutorials
  })
}

export const fetchTutorialSteps = {
  request: (tutorialId) => ({ type: FETCH_TUTORIAL_STEPS.REQUEST, tutorialId }),
  success: (tutorialId, tutorial) => ({
    type: FETCH_TUTORIAL_STEPS.SUCCESS,
    tutorialId,
    tutorial
  })
}

export const updateStep = (step) => ({ type: UPDATE_STEP, step })
export const updateStepNonBlocking = (step) => ({ type: UPDATE_STEP_NB, step })
export const playStepAnimation = () => ({ type: ANIMATE_STEP })
export const playAllStepAnimation = () => ({ type: ANIMATE_ALL })
export const termAllStepAnimation = () => ({ type: ANIMATE_ALL_TERM })
export const updateStepFrame = (index) => ({ type: UPDATE_FRAME, index })
